import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, Divider, Grid, Header, Icon, Input, Label, Segment } from 'semantic-ui-react';
import * as UserAdmin from '..';
import { ApplicationState, routes, strings } from '../..';
import { AnagraficaCustom, DestinatarioCustom } from '../models';
import { mediaStyles, MediaContextProvider, Media } from '../../core'; 
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from '../../../application-insight/telemetryService';

const connector = connect(
    (state: ApplicationState) => ({
        anagraficheCustom: state.userAdmin.anagrafiche
    }),
    UserAdmin.actions
)
type PropsFromRedux = ConnectedProps<typeof connector>

type AnagraficheCustomProps = PropsFromRedux

class AnagraficheCustom extends React.Component<AnagraficheCustomProps> {

    componentDidMount() {
        this.props.loadAnagraficheCustom();
    }

    render() {
        const { anagraficheCustom } = this.props;
        return (            
            <>
                <style>{mediaStyles}</style>
                <MediaContextProvider>
                    <Media greaterThanOrEqual="tablet">
                        <Grid centered>
                            {this.renderIntestazione()}
                            {anagraficheCustom.map(this.renderAnagraficaCustom)}
                            <Grid.Row />
                            {this.renderSalvataggio()}
                        </Grid>
                    </Media>
                    <Media at="mobile">
                        <Grid centered>
                            {this.renderIntestazione()}
                            {this.renderSalvataggio()}
                            {anagraficheCustom.map(this.renderAnagraficaCustomMobile)}
                        </Grid>
                    </Media>
                </MediaContextProvider>
            </>
        );
    }

    renderIntestazione = () => (
        <Grid.Row key='intestazione'>
            <Header as='h2' textAlign='center'>
                <Icon name='address book outline' />
                <Header.Content>
                    {strings.userAdmin.anagrafiche.titolo}
                    <Header.Subheader>{strings.userAdmin.anagrafiche.sottotitolo}</Header.Subheader>
                </Header.Content>
            </Header>
        </Grid.Row>
    )

    renderSalvataggio = () => (
        <Grid.Row columns={2} key='salvataggio'>
            <Grid.Column textAlign='right' mobile='8' tablet='7' computer='5'>
                <Button primary icon labelPosition='left' as={Link} to={routes.core.main}>
                    <Icon name='arrow left' />
                    {strings.core.azioni.indietro}
                </Button>
            </Grid.Column>
            <Grid.Column textAlign='left' mobile='8' tablet='7' computer='4'>
                <Button icon labelPosition='left' color='green' onClick={this.salvaAnagraficheCustom}>
                    <Icon name='save' />
                    {strings.core.azioni.salva}
                </Button>
            </Grid.Column>
        </Grid.Row>
    )

    renderAnagraficaCustom = (anagrafica: AnagraficaCustom) => (
        <React.Fragment key={anagrafica.idAnagrafica}>
            <Grid.Row columns={2}>
                <Grid.Column tablet='7' computer='7' widescreen='5' textAlign='left' verticalAlign='middle'>
                    <h3><strong>{anagrafica.ragioneSociale}</strong></h3>
                </Grid.Column>
                <Grid.Column tablet='8' computer='6' widescreen='5'>
                    <Input fluid placeholder='Imposta la descrizione custom' value={anagrafica.ragioneSocialeCustom}
                            onChange={(_, data) => this.modificaElementoCustom(anagrafica, data.value)}>
                        <input />                            
                        {anagrafica.isModificata() ? this.renderLabelModificato() : null}
                    </Input>
                </Grid.Column>
            </Grid.Row>
            {anagrafica.destinatari.map(this.renderDestinatarioCustom)}
        </React.Fragment>
    )

    renderDestinatarioCustom = (destinatario: DestinatarioCustom) => (
        <Grid.Row key={destinatario.idDestinatario} style={{ paddingTop: 1, paddingBottom: 1 }}>
            <Grid.Column tablet='1' computer='1' widescreen='1' />
            <Grid.Column tablet='6' computer='6' widescreen='4' textAlign='left' verticalAlign='middle'>
                <h4><strong>{destinatario.destinatario}</strong></h4>
            </Grid.Column>
            <Grid.Column tablet='8' computer='6' widescreen='5'>
                <Input fluid placeholder='Imposta la descrizione custom' value={destinatario.destinatarioCustom}
                        onChange={(_, data) => this.modificaElementoCustom(destinatario, data.value)}>
                    <input />
                    {destinatario.isModificato() ? this.renderLabelModificato() : null}
                </Input>
            </Grid.Column>
        </Grid.Row>
    );

    renderAnagraficaCustomMobile = (anagrafica: AnagraficaCustom) => {
        return (
            <>
                <Grid.Row key={anagrafica.idAnagrafica}>
                    <Grid.Column width='16' textAlign='left'>
                        <label><h3><strong>{anagrafica.ragioneSociale}</strong></h3></label>
                        <Input fluid placeholder='Imposta la descrizione custom' value={anagrafica.ragioneSocialeCustom}
                            onChange={(_, data) => this.modificaElementoCustom(anagrafica, data.value)}>
                            <input />                            
                            {anagrafica.isModificata() ? this.renderLabelModificato() : null}
                        </Input>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row />
                {anagrafica.destinatari.map(this.renderDestinatarioCustomMobile)}
                <Grid.Row />
            </>
        );
    }

    renderDestinatarioCustomMobile = (destinatario: DestinatarioCustom) => {
        return (
            <Grid.Row key={destinatario.idDestinatario} style={{ paddingTop: 1, paddingBottom: 1 }}>
                <Grid.Column width='16' textAlign='left'>
                    <label><strong>{destinatario.destinatario}</strong></label>
                    <Input fluid placeholder='Imposta la descrizione custom' value={destinatario.destinatarioCustom}
                           onChange={(_, data) => this.modificaElementoCustom(destinatario, data.value)}>
                        <input />
                        {destinatario.isModificato() ? this.renderLabelModificato() : null}
                    </Input>
                </Grid.Column>
            </Grid.Row>
        );
    }

    renderLabelModificato = () => {
        return (
            <Label icon='asterisk' color='teal' corner='right' size='mini' />
        );
    }

    modificaElementoCustom = (oggetto: AnagraficaCustom | DestinatarioCustom, value: string) => {
        oggetto.modifica(value);
        
        this.setState({});
    }

    salvaAnagraficheCustom = () => {
        const { anagraficheCustom } = this.props;

        this.props.saveAnagraficheCustom(anagraficheCustom);
    }
}

export default connector(withAITracking(ai.reactPlugin, AnagraficheCustom, "AnagraficheCustom"));